import { useId, useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'

/** "Why the AI suggested this" — the proposal's rationale, closed until asked for. */
export function ProposalRationale({ rationale }: { rationale: string }) {
  const [open, setOpen] = useState(false)
  const panelId = useId()
  const Chevron = open ? ChevronDown : ChevronRight
  return (
    <div className="text-sm">
      <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1 text-xs text-muted-foreground underline-offset-2 hover:underline">
        <Chevron aria-hidden="true" className="size-3" />
        Why the AI suggested this
      </button>
      {open && <p id={panelId} className="mt-1 whitespace-pre-wrap rounded-xl border border-border bg-muted/30 p-3">{rationale}</p>}
    </div>
  )
}
